import { APICfg } from 'services/api/api'
import { APIBaseProductPackage, BaseProductPackage } from './common'

const apiCfg: APICfg = {
  endpoint: 'musicpackage',
  parse: (req: APIBaseProductPackage): BaseProductPackage => req,
  write: async (req: BaseProductPackage): Promise<APIBaseProductPackage> => req,
}

export default apiCfg
